import { render, staticRenderFns } from "./DatabaseAdd.vue?vue&type=template&id=05d2ac8c&"
import script from "./DatabaseAdd.vue?vue&type=script&lang=js&"
export * from "./DatabaseAdd.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports